import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";
import { motion } from "framer-motion";
import { useLocalContext } from "../../context/LocalContext";
import { FaTelegramPlane } from "react-icons/fa";

const Banner = () => {
  const navigate = useNavigate();
  const { openTelegram } = useLocalContext();

  return (
    <section className="clean-banner">
      <div className="clean-banner-inner">
        <motion.div
          className="clean-banner-left"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="clean-pill">What we offer</span>

          <h1>
            Reliable IT & Digital Services  
            <span>for small businesses</span>
          </h1>

          <p className="clean-subtext">
            From printer repairs to bookkeeping, CRM development to antivirus
            security — get clear, outcome-focused support that keeps your
            business running smoothly.
          </p>

          <div className="clean-actions">
            <button className="primary-btn" onClick={openTelegram}>
              <FaTelegramPlane /> Connect on Telegram
            </button>

            <button
              className="ghost-btn"
              onClick={() => navigate("/services")}
            >
              Explore All Services →
            </button>
          </div>
        </motion.div>

        <motion.div
          className="clean-banner-right"
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <div className="metric-card">
            <h3>98%</h3>
            <p>Customer satisfaction across all service categories.</p>
          </div>

          <div className="metric-row">
            <div className="metric-box">
              <h4>3000+</h4>
              <span>Tickets resolved</span>
            </div>
            <div className="metric-box">
              <h4>120+</h4>
              <span>Businesses supported</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
